export default "Prime énergie (CEE) 2026 — Le guide complet du dispositif | Solution Éco France";
